import { useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'qs';

const asIs = (arg) => arg;

const useSearchParamsState = (
  key,
  defaultValue,
  parse = asIs,
  arrayFormat = 'brackets'
) => {
  const { search } = useLocation();
  const history = useHistory();
  const params = useMemo(() => {
    return qs.parse(search, {
      ignoreQueryPrefix: true,
      // comma: arrayFormat === 'comma',
    });
  }, [search]);
  const [state, setState] = useState(() => {
    if (params[key]) {
      const v = parse(params[key]);
      return v;
    } else {
      return defaultValue;
    }
  });

  useEffect(() => {
    setState(params[key] ? parse(params[key]) : defaultValue);
  }, [params[key]]);

  const setNewState = useCallback(
    (newValue) => {
      setState(newValue);
      const currentParams = qs.parse(window.location.search, {
        ignoreQueryPrefix: true,
      });
      history.push(
        '?' +
          qs.stringify(
            { ...currentParams, [key]: newValue || undefined },
            {
              encode: false,
              arrayFormat: arrayFormat,
            }
          )
      );
    },
    [key, arrayFormat]
  );

  return [state, setNewState];
};

export default useSearchParamsState;
